import React from "react"
import { Global, css } from "@emotion/core"
import { ThemeProvider } from "./theme"

const GlobalStyles = css`
  html {
    // // colorS
    // --color-text: #313453;
    // --color-off-text: #3134537c;
    // --color-background: white;
    // --color-lighter-primary: #fcf3e4;
    // --color-primary: #fceeb0;
    // --color-darker-primary: #fec185;
    // --color-gradient-primary: #f8745c;
    // --color-gradient-secondary: #d6456c;
    // --color-interactive-light: #a923ff;
    // --color-interactive-light-50: rgba(169,35,255,0.5);
    // --color-interactive-dark: #553143;
    --color-accent-gradient: linear-gradient(
      to right,
      var(--color-gradient-primary),
      var(--color-gradient-secondary)
    );
    --color-accent-gradient-alt: linear-gradient(
      to left,
      var(--color-gradient-primary),
      var(--color-gradient-secondary)
    );

    --color-header-gradient: linear-gradient(
      to top,
      var(--color-gradient-header-primary),
      var(--color-gradient-header-secondary)
    );

    // MEDIA
    --left-right-grid-areas: 'left left right';
    --no-mobile-block: block;
    --no-phone-block: block;
    --no-mobile-inline-block: inline-block;
    --no-phone-inline-block: inline-block;
    --mobile-only-flex: none;
    
    @media (max-width: 1200px) {
    }

    @media (max-width: 992px) {
    }

    @media (max-width: 768px) {
      --left-right-grid-areas: 'left' 'right';
      --no-mobile-block: none;
      --no-mobile-inline-block: none;
      --mobile-only-flex: flex;
    }

    @media (max-width: 576px) {
      --no-phone-block: none;
      --no-phone-inline-block: none;
    }
  }

  button,
  input[type="submit"],
  input[type="reset"] {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: none;
  }
  input[type="button"]{
    outline:none;
  }
  input[type="button"]::-moz-focus-inner {
      border: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  body {
    background: var(--color-background);
    color: var(--color-text);
  }
  
  .gatsby-highlight-code-line {
    background-color: #feb;
    display: block;
    margin-right: -1em;
    margin-left: -1em;
    padding-right: 1em;
    padding-left: 0.75em;
    border-left: 0.25em solid #f99;
  }

    /**
   * Remove the default PrismJS theme background-color, border-radius, margin,
   * padding and overflow.
   * 1. Make the element just wide enough to fit its content.
   * 2. Always fill the visible space in .gatsby-highlight.
   * 3. Adjust the position of the line numbers
   */
  .gatsby-highlight pre[class*="language-"] {
    background-color: transparent;
    margin: 0;
    padding: 0;
    overflow: initial;
    float: left; /* 1 */
    min-width: 100%; /* 2 */
  }

  /* Adjust the position of the line numbers */
  .gatsby-highlight pre[class*="language-"].line-numbers {
    padding-left: 2.8em;
  }

  /**
   * If you only want to use line numbering
   */

  .gatsby-highlight {
    max-width: 100%;
    padding: 9px;
    margin-bottom: 40px;
    font-size: 1.1rem;
    position: relative;
    overflow: auto;
  }

  .gatsby-highlight pre[class*="language-"].line-numbers {
    padding: 0;
    padding-left: 2.8em;
    overflow: initial;
  }

  @media (max-width: 576px) {
    .katex { font-size: 0.9em !important; } 
  }
`

const App = ({ children }) => {
  return (
    <>
      <Global styles={GlobalStyles} />
        <ThemeProvider>
          {children}
        </ThemeProvider>
    </>
  )
}

export default App
